export namespace Actions {
    export const IS_USER_LOADING: string = 'IS_USER_LOADING';
    export const IS_USER_AUTHORIZED: string = 'IS_USER_AUTHORIZED';
    export const SHOW_OVERLAY: string = 'SHOW_OVERLAY';
    export const HIDE_OVERLAY: string = 'HIDE_OVERLAY';
    export const CHANGE_VIEW: string = 'CHANGE_VIEW';
    export const IS_LOADING: string = 'IS_LOADING';
    export const SHOW_FORGOT_PASSWORD: string = 'SHOW_FORGOT_PASSWORD';
    export const PRELOADER_IS_VISIBLE: string = 'PRELOADER_IS_VISIBLE';
    export const UPDATE_USER_PHONE: string = 'UPDATE_USER_PHONE';
    export const SHOW_PROVIDE_PIN: string = 'SHOW_PROVIDE_PIN';
    export const SHOW_ALERT: string = 'SHOW_ALERT';
    export const HIDE_ALERT: string = 'HIDE_ALERT';

}

export namespace Command {
    export const CHANGE_PIN: string = 'CHANGE_PIN';
    export const RECOVER_PASSWORD: string = 'RECOVER_PASSWORD';
}

export namespace Languages {
    export const LV: string = 'lv';
    export const EN: string = 'en';
    export const RU: string = 'ru';
    export const ALL: string[] = [Languages.LV, Languages.EN, Languages.RU];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/Constants.ts